(function () {
  'use strict';

  console.log('colour-group-swatches.js loaded');

  var _memCache = {};
  var CACHE_TTL_MS = 30 * 60 * 1000; // 30 minutes

  function previewParam() {
    var match = window.location.search.match(/[?&](preview_theme_id=[^&]+)/);
    return match ? '&' + match[1] : '';
  }

  function appendSections(url, section) {
    var sep = url.indexOf('?') !== -1 ? '&' : '?';
    return url + sep + 'sections=' + encodeURIComponent(section) + previewParam();
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function findProductSection() {
    var el = document.querySelector('[data-section-type="product"]');
    if (!el) {
      var form = document.querySelector('form[action="/cart/add"]');
      if (form) el = form.closest('[id^="shopify-section-"]');
    }
    if (!el) return null;
    var sectionId = el.dataset.sectionId || el.id.replace(/^shopify-section-/, '');
    return { el: el, sectionId: sectionId };
  }

  function sessionGet(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (Date.now() - entry.ts > CACHE_TTL_MS) {
        sessionStorage.removeItem(key);
        return null;
      }
      return entry.data;
    } catch (e) { return null; }
  }

  function sessionSet(key, val) {
    try { sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), data: val })); } catch (e) {}
  }

  window.__cgSwapProduct = async function (url) {
    var found = findProductSection();
    if (!found) { window.location.assign(url); return; }

    var section = found.el;
    var sectionId = found.sectionId;

    section.style.opacity = '0.4';
    section.style.pointerEvents = 'none';
    section.style.transition = 'opacity 0.15s';

    try {
      var resp = await fetch(appendSections(url, sectionId));
      if (!resp.ok) throw new Error('HTTP ' + resp.status);

      var data = await resp.json();
      var html = data[sectionId];
      if (!html) throw new Error('Section key missing');

      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var newSection = tmp.firstElementChild;
      if (!newSection) throw new Error('Empty section HTML');

      newSection.style.opacity = '0';
      newSection.style.transition = 'opacity 0.2s';

      section.parentNode.replaceChild(newSection, section);
      history.replaceState({}, document.title, url);

      newSection.querySelectorAll('script:not([src])').forEach(function (s) {
        var t = (s.type || '').toLowerCase();
        if (t && t !== 'text/javascript') return;
        var ns = document.createElement('script');
        ns.textContent = s.textContent;
        s.parentNode.replaceChild(ns, s);
      });

      document.dispatchEvent(new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: { sectionId: sectionId }
      }));

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          newSection.style.opacity = '';
          newSection.style.transition = '';
        });
      });

    } catch (err) {
      console.warn('colour-group-swatches: swap failed:', err.message);
      window.location.assign(url);
    }
  };

  function ColourGroupSwatches(el) {
    this.el = el;
    this.colourGroup = decodeURIComponent(el.dataset.colourGroup);
    this.productHandle = el.dataset.productHandle;
    this.inner = el.querySelector('.colour-group-swatches__inner');
    try { this.translations = JSON.parse(el.dataset.translations || '{}'); } catch (e) { this.translations = {}; }
    this.fetchAndRender();
  }

  function getColour(product) {
    for (var i = 0; i < product.tags.length; i++) {
      if (product.tags[i].indexOf('Colour: ') === 0) return product.tags[i].replace('Colour: ', '');
    }
    for (var j = 0; j < product.options.length; j++) {
      var name = product.options[j].name.toLowerCase();
      if (name === 'colour' || name === 'color') {
        var vals = product.options[j].values;
        return vals && vals[0] ? vals[0] : '';
      }
    }
    return '';
  }

  function getColourType(product) {
    for (var i = 0; i < product.tags.length; i++) {
      if (product.tags[i].indexOf('colour-type:') === 0) return product.tags[i].replace('colour-type:', '');
    }
    return '';
  }

  async function fetchAllByTag(tag) {
    var all = [];
    var page = 1;
    var limit = 250;
    while (true) {
      var url = '/products.json?tag=' + encodeURIComponent(tag) + '&limit=' + limit + '&page=' + page + previewParam();
      var resp = await fetch(url);
      if (!resp.ok) break;
      var data = await resp.json();
      var batch = data.products || [];
      all = all.concat(batch);
      if (batch.length < limit) break;
      page++;
      if (page > 10) break;
    }
    return all;
  }

  ColourGroupSwatches.prototype.fetchAndRender = async function () {
    var self = this;
    var exactTag = 'colour-group:' + this.colourGroup;
    var cacheKey = 'cg_swatches_' + this.colourGroup;

    if (_memCache[cacheKey]) { self.render(_memCache[cacheKey]); return; }

    var cached = sessionGet(cacheKey);
    if (cached && cached.length) {
      _memCache[cacheKey] = cached;
      self.render(cached);
      return;
    }

    try {
      var allProducts = await fetchAllByTag(exactTag);
      var products = allProducts.filter(function (p) {
        return p.tags.indexOf(exactTag) !== -1;
      });

      var swatches = products.map(function (p) {
        var colour = getColour(p);
        var colourType = getColourType(p);
        var swatchFallback = colour ? colour.split(' ').pop().toLowerCase().replace(/[^a-z0-9]/g, '-') : '';
        var featuredImage = p.images && p.images[0] ? p.images[0].src.split('?')[0] : '';
        return {
          handle: p.handle,
          url: '/products/' + p.handle,
          colour: colour,
          colourType: colourType,
          swatchFallback: swatchFallback,
          featuredImage: featuredImage
        };
      });

      _memCache[cacheKey] = swatches;
      sessionSet(cacheKey, swatches);
      self.render(swatches);
    } catch (e) {
      console.warn('colour-group-swatches: fetchAndRender error:', e);
    }
  };

  ColourGroupSwatches.prototype.render = function (products) {
    var self = this;
    var translations = self.translations || {};
    var groupOrder = [];
    var groups = {};

    products.forEach(function (p) {
      var key = p.colourType || '';
      if (!groups[key]) { groups[key] = []; groupOrder.push(key); }
      groups[key].push(p);
    });

    var coreIdx = groupOrder.indexOf('');
    if (coreIdx > 0) { groupOrder.splice(coreIdx, 1); groupOrder.unshift(''); }

    var html = [];
    groupOrder.forEach(function (label, idx) {
      var items = groups[label];
      if (!items || !items.length) return;
      var tKey = label ? label.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '') : 'core';
      var tLabel = translations[tKey] || label || translations['core'] || 'Core';
      var marginTop = idx === 0 ? '0' : '12px';
      html.push('<div class="product-single__subtitle colour-group-swatches__group-label" style="margin-top:' + marginTop + ';">' + escapeHtml(tLabel) + '</div>');
      html.push('<div class="colour-group-swatches__group" style="display:flex;flex-wrap:wrap;gap:6px;margin-top:8px;margin-bottom:4px;">');
      items.forEach(function (p) {
        var isActive = p.handle === self.productHandle;
        var title = escapeHtml(p.colour || p.handle);
        var imgSrc = escapeHtml(p.featuredImage || '');
        var border = isActive ? '#000' : 'transparent';
        html.push(
          '<button type="button"' +
          ' class="colour-swatch-link' + (isActive ? ' is-active' : '') + '"' +
          ' data-url="' + escapeHtml(p.url) + '"' +
          ' onclick="window.__cgSwapProduct(this.dataset.url)"' +
          ' title="' + title + '" aria-label="' + title + '"' +
          (isActive ? ' aria-current="true" disabled' : '') +
          ' style="display:inline-block;width:52px;height:52px;border-radius:4px;overflow:hidden;border:2px solid ' + border + ';padding:0;cursor:pointer;background:none;">' +
          (imgSrc
            ? '<img src="' + imgSrc + '" alt="' + title + '" width="52" height="52" style="width:100%;height:100%;object-fit:cover;pointer-events:none;">'
            : '<span style="display:block;width:100%;height:100%;background-color:' + escapeHtml(p.swatchFallback) + ';pointer-events:none;"></span>') +
          '</button>'
        );
      });
      html.push('</div>');
    });

    if (!html.length) {
      self.el.style.display = 'none';
      return;
    }

    self.el.style.display = '';
    this.inner.innerHTML = html.join('');
  };

  function initSwatches() {
    document.querySelectorAll('.colour-group-swatches:not([data-init])').forEach(function (el) {
      el.setAttribute('data-init', '');
      new ColourGroupSwatches(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatches);
  } else {
    initSwatches();
  }

  document.addEventListener('shopify:section:load', function () {
    initSwatches();
  });

})();
